module.exports = __webpack_public_path__ + "img/메인우측배너.5f20d3e1.png";